import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ResourceAdmin from "@/components/admin/ResourceAdmin";
import { PageTitle } from "@/components/admin/AdminLayout";
import { APARTMENTS, OPTIONS, MEDIA, REVIEWS, POIS, SECTIONS, FAQ, SEO_PAGES } from "@/pages/admin/resources";

function useCtx() {
  const [ctx, setCtx] = useState({ apartments: [], pois: [] });
  useEffect(() => { Promise.all([api.get("/admin/apartments"), api.get("/admin/pois")]).then(([a, p]) => setCtx({ apartments: a.data, pois: p.data })); }, []);
  return ctx;
}

export function ApartmentsAdmin() { return <ResourceAdmin cfg={APARTMENTS} ctx={useCtx()} />; }
export function OptionsAdmin() { return <ResourceAdmin cfg={OPTIONS} ctx={useCtx()} />; }
export function MediaAdmin() { return <ResourceAdmin cfg={MEDIA} ctx={useCtx()} />; }
export function ReviewsAdmin() { return <ResourceAdmin cfg={REVIEWS} ctx={useCtx()} />; }
export function FaqAdmin() { return <ResourceAdmin cfg={FAQ} ctx={useCtx()} />; }
export function SeoAdmin() { return <ResourceAdmin cfg={SEO_PAGES} ctx={useCtx()} />; }

export function QueyrasAdmin() {
  const ctx = useCtx();
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "pois";
  return (
    <div data-testid="admin-queyras">
      <PageTitle title="Découvrir le Queyras" text="Points d'intérêt (avec « Coup de cœur de Badouille ») et rubriques de la destination.">
        <div className="flex gap-2">{[["pois", "Points d'intérêt"], ["sections", "Rubriques"]].map(([k, l]) => <button key={k} onClick={() => setSp({ tab: k })} className={`px-4 py-2 rounded-full text-xs border ${tab === k ? "bg-forest text-ecru border-forest" : "bg-white border-sand"}`} data-testid={`queyras-tab-${k}`}>{l}</button>)}</div>
      </PageTitle>
      {tab === "pois" ? <ResourceAdmin cfg={POIS} ctx={ctx} embedded /> : <ResourceAdmin cfg={SECTIONS} ctx={ctx} embedded />}
    </div>
  );
}
